/**
 *
 * Gsap Tween
 */

import { Tween } from "./index.types";
import gsap from "gsap";

export class GSAPTween extends gsap.core.Tween implements Tween  {
    public id: string;

    constructor(target: gsap.TweenTarget, vars: gsap.TweenVars, id?: string, time?: number) {
        super(target, { ...vars, paused: true }, time);
        this.id = id ? id : crypto.randomUUID();
    }

    then(
        onFulfilled?: ((value: Omit<this, "then">) => any) | null,
        onRejected?: ((reason: any) => any) | null
    ): Promise<this> {
        const thenFn = super.then as unknown as (
            onFulfilled?: ((value: Omit<this, "then">) => any),
            onRejected?: ((reason: any) => any)
        ) => Promise<this>;
        return thenFn.call(this, onFulfilled ?? undefined, onRejected ?? undefined);
    }

    playPause(time?: number) {
        this.play()
        if (time === undefined) this.pause();
        else this.pause(time);
    }

    reset() {
        this.totalProgress(0)
        this.progress(0)
        this.pause()
        return this;
    }
}
